import React from 'react'
import MatchedDetailView from 'tennders-transactions/views/booked/MatchedDetailView'
import UnMatchedDetailView from 'tennders-transactions/views/unbooked/UnMatchedDetailView'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useSession from 'tennders-auth/hooks/useSession'

const TransactionHeader = () => {
  const { transaction, closeTransaction } = useTransaction()
  const { isBroker } = useSession()

  if (!transaction?.matchedLoad && !transaction?.matchedTruck) {
    return (
      <header className="detailed-header">

      </header>
    )
  }

  return transaction?.matchedLoad && transaction?.matchedTruck && !transaction?.isOfferable
    ? (
      <MatchedDetailView
        close={closeTransaction}
        transaction={transaction}
        broker={isBroker()}
      />
    )
    : (
      <UnMatchedDetailView
        close={closeTransaction}
        transaction={transaction}
        broker={isBroker()}
      />
    )
}

export default React.memo(TransactionHeader)
